import { useQuery } from '@tanstack/react-query';
import { appendColorAndKeyToLabelObject } from 'screens/performanceReview/ResultPage/components/ResultSpiderChart/hooks/dataHooks';

import { VISIBLE_PROVIDER_TYPES_COLOR_MAPPING } from 'constants/ProjectConstants';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getReviewFormRatingDetails } from 'services/reviews';

const getData = async ({ reviewId, employeeId, providerId }) => {
  try {
    const response = await getReviewFormRatingDetails({
      reviewId,
      employeeId,
      providerId,
    });
    let { providerTypes } = response;
    const providerKey = 'providerTypeKey';
    providerTypes = appendColorAndKeyToLabelObject({
      LabelObject: providerTypes,
      primaryKey: providerKey,
      colorMapper: VISIBLE_PROVIDER_TYPES_COLOR_MAPPING,
    });
    return {
      ...response,
      providerTypes,
    };
  } catch (error) {
    console.log('Error fetching rating data :', error);
  }

  return null;
};

const useReviewFormRatingData = ({ reviewId, employeeId, providerId }) =>
  useQuery([REACT_QUERY_KEYS.ReviewFormFillingRatingData, reviewId, employeeId, providerId], () =>
    getData({ reviewId, employeeId, providerId })
  );

export default useReviewFormRatingData;
